import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters, mapState } from 'vuex';
import { isOwner } from 'api/owners/rules';
import { seesAdminScreens } from 'api/core/roles';
import { loaderPrefs, saveLastLook } from "./loaderPrefs";
import UiLoadCard from 'components/ui/UiLoadCard';
import { ATLAS, FAN } from 'components/community-wizard/look';
var SLOW_MS = 10000; // held (dev): the steps play over and over, one tick per DEMO_TICK_MS

var DEMO_TICK_MS = 900;
var PAUSE_MS = 10000;
var DEMO_STEPS = ['connect', 'account', 'places', 'communities', 'news'];
var FONTS = {
  atlas: ATLAS.fontCss,
  duin: FAN.fontCss
};
export default {
  name: 'AppLoader',
  components: {
    UiLoadCard: UiLoadCard
  },
  data: function data() {
    return {
      prefs: loaderPrefs,
      slow: false,
      demoTicks: 0
    };
  },
  computed: _objectSpread({}, mapState(['user', 'loginKnown']), {}, mapGetters(['startSteps']), {
    // the look's tokens: the loader's --al-* read them (app-loader.css)
    lookClass: function lookClass() {
      return (this.look === 'atlas' ? ATLAS : FAN).lookClass;
    },
    look: function look() {
      if (this.prefs.look) return this.prefs.look;
      if (!this.loginKnown) return this.prefs.lastLook;
      return this.user && (isOwner(this.user) || seesAdminScreens(this.user)) ? 'atlas' : 'duin';
    },
    // held or paused (dev): a logged-in first load played by itself, over and over or once slowly
    demo: function demo() {
      return this.prefs.hold || this.prefs.pause;
    },
    baseSteps: function baseSteps() {
      return this.demo ? DEMO_STEPS.map(function (key) {
        return {
          key: key,
          done: false
        };
      }) : this.startSteps;
    },
    // the steps ticked in their order: the first one not done is busy, the ones after it wait
    ticked: function ticked() {
      if (this.prefs.hold) return this.demoTicks % (this.baseSteps.length + 3);
      if (this.prefs.pause) return Math.min(this.demoTicks, this.baseSteps.length);
      var i = this.baseSteps.findIndex(function (step) {
        return !step.done;
      });
      return i === -1 ? this.baseSteps.length : i;
    },
    shownSteps: function shownSteps() {
      var _this = this;

      return this.baseSteps.map(function (step, i) {
        return {
          key: step.key,
          label: _this.$t('app_loader.steps.' + step.key),
          state: i < _this.ticked ? 'done' : i === _this.ticked ? 'busy' : 'todo'
        };
      });
    },
    shownProgress: function shownProgress() {
      return Math.min(1, this.ticked / this.baseSteps.length);
    }
  }),
  watch: {
    look: {
      immediate: true,
      handler: function handler(look) {
        this.loadFont(look);
      }
    },
    demo: {
      immediate: true,
      handler: function handler() {
        this.playDemo();
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.slowTimer = setTimeout(function () {
      _this2.slow = true;
    }, SLOW_MS);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.slowTimer);
    clearInterval(this.demoTimer); // the next first load starts in this look

    if (this.loginKnown && !this.prefs.look) saveLastLook(this.look);
  },
  methods: {
    // held: a tick every DEMO_TICK_MS, round and round; paused: the steps spread over PAUSE_MS, then the page opens
    playDemo: function playDemo() {
      var _this3 = this;

      clearInterval(this.demoTimer);
      this.demoTicks = 0;

      if (this.prefs.hold) {
        this.demoTimer = setInterval(function () {
          _this3.demoTicks++;
        }, DEMO_TICK_MS);
      } else if (this.prefs.pause) {
        var tick = PAUSE_MS / (DEMO_STEPS.length + 1);
        this.demoTimer = setInterval(function () {
          _this3.demoTicks++;

          if (_this3.demoTicks > DEMO_STEPS.length) {
            clearInterval(_this3.demoTimer);

            _this3.$emit('open');
          }
        }, tick);
      }
    },
    retry: function retry() {
      window.location.reload();
    },
    // the look's web font, one link in <head> (it stays: the pages in that look use it too)
    loadFont: function loadFont(look) {
      var href = FONTS[look];
      if (!href || document.querySelector('link[href="' + href + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
  }
};